import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import * as hotelActions from './../../../../actions/hotelAction';
import * as rateActions from "./../../../../actions/rateAction";
import * as payAtHotelActions from "./../../../../actions/payAtHotelAction";
import PayAtHotel from './PayAtHotel';

const mapStateToProps = state => {
    return {
        hotelState: state.hotelReducer,
        rateState: state.rateReducer,
        payAtHotelState: state.payAtHotelReducer,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        getAllHotel: () => dispatch(hotelActions.getAllHotels()),
        getListRatesByHotels: (filters) => dispatch(rateActions.getListRatesByHotels(filters)),
        getPayAtHotel: () => dispatch(payAtHotelActions.getPayAtHotel()),
        getProfileTypes: () => dispatch(payAtHotelActions.getProfileTypes()),
        updatePayAtHotel: (payAtHotel) => dispatch(payAtHotelActions.updatePayAtHotel(payAtHotel)),
    }
};

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(PayAtHotel));
